

import { Injectable, Inject } from '@angular/core';
import { Observable, of, combineLatest, onErrorResumeNext, Subject } from 'rxjs';
// tslint:disable-next-line: max-line-length
import { DwMdFormActionHandler, DwMdFormActionState, DwMdFormActionResult, DwFormAction, DwSecuritySSOService, DwSecurityRepositoryServiceToken, 
         DwSecurityRepositoryService, DwSecurityUserService, DwMdFormContextInfo, DwOrmDataService, DwOrmDataServiceToken, DwMdFormInitActionHandler, 
         DwMdFormInitActionState, DwAction, DwActionType, DwFormActionConfigDefaultComponent,
         DwMessagingService, DwMessageSeverity } from '@devwareapps/devware-cap';
import { map, flatMap, tap, catchError } from 'rxjs/operators';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { PayJobChangeEntity } from 'src/app/meta-data/app-meta-data.service';
import { ConfigService } from 'src/environments/environment';
import { FormGroup } from '@angular/forms';
import { WachterUserExt } from 'src/app/shared/models/wachter-user.model';
import { AppPermissions } from 'src/app/meta-data/app-permissions.enum';
import { AppMetaDataItemNames } from 'src/app/meta-data/app-meta-data.service';
import { debugOutputAstAsTypeScript } from '@angular/compiler';



@DwAction ({
  isGlobal: false,
  actionType: DwActionType.formAction,
  configComponent: DwFormActionConfigDefaultComponent,
  display: 'PAF Pay Job Change Resend Approval',
  keyName : 'pafResendApproval',
  actionMessage: '',
  parentItemName : AppMetaDataItemNames.PayJobChange,
  defaultButtonConfig : {
    buttonText : 'Resend Approval Email',
    buttonTitle : 'Resend Approval Email',
    command : 'resendApprovalEmail',
    iconClass : 'fas fa-envelope',
    buttonClass : 'btn btn-success'
  }
})
@Injectable({
  providedIn: 'root'
})
export class PayJobChangeResendApprovalActionService implements DwMdFormActionHandler, DwMdFormInitActionHandler  {

   constructor(
     protected msalHandler: DwSecuritySSOService,
      protected securityService: DwSecurityUserService,
     @Inject(DwSecurityRepositoryServiceToken) protected securityRepository: DwSecurityRepositoryService,
     @Inject(DwOrmDataServiceToken) protected ormDataService: DwOrmDataService,
     protected http: HttpClient,
     protected messageService: DwMessagingService) {
  }

  /**
   * Initialize the action to customize any config items
   * @param formInitActionState form state
   */
  initAction(formInitActionState: DwMdFormInitActionState) {
    formInitActionState.formApi
        .getFormDataChanges<PayJobChangeEntity>(350)
        .subscribe(value => this.updateButton(formInitActionState));
  }

  /**
   * Updates the button config based on if they can approve or not
   * @param formInitActionState form state
   */
  protected updateButton(formInitActionState: DwMdFormInitActionState) {
    const buttonConfig = formInitActionState.actionPreference.buttonConfig;
    // Set button disabled based on can Approve result << original comments...this is NOT what it is doing
    if (buttonConfig) {
      buttonConfig.hidden = !(!this.isApproved(formInitActionState) && this.canPress(formInitActionState));
    }
  }

  handleAction(formActionState: DwMdFormActionState): Observable<DwMdFormActionResult> {
    const result: DwMdFormActionResult = { success : true, returnAfter : true, message : 'Email Sent!' };
    const cannotApproveResult: DwMdFormActionResult = { success : false, message : 'You cannot press this button.' };

    if (!this.canPress(formActionState)) 
      return of (cannotApproveResult);

    const payJobChange: PayJobChangeEntity = formActionState.formApi.getFormData();
    if (ConfigService.config.features.paf.workflowPort === true){
      const url = ConfigService.config.apiRoot + '/payJobChange/approval';

      var headers = new HttpHeaders().set('Content-Type', 'text/plain; charset=utf-8');
      const resultObs = this.http.get(url + '?mode=1&id=' + payJobChange.PayJobChangeId, { headers, responseType: 'text' as 'json' })
                                 .pipe(map((res: any) => { 
                                          if (res) { 
                                            cannotApproveResult.message = res; 
                                            return cannotApproveResult; 
                                          }
                                          else
                                            this.sendInfoMsg('Email scheduled successfully for resend!');
                                          return result; 
                                        }),
                                        catchError(err => { 
                                          cannotApproveResult.message = err.message; 
                                          return of(cannotApproveResult);
                                        }));
      this.sendInfoMsg('Attempting to resend...');
      return resultObs;
    }
    // else
    //   //Deprecated logic kept during the port temporarily
    //   this.http.get(ConfigService.config. wAppsApi + 'api/PayJobChange?PayJobChangeId=' + payJobChange.PayJobChangeId)
    //            .subscribe(x => console.log('Email sent!'));
  }

  private sendInfoMsg(msg : string){
    this.messageService.showMessage({messageHeading: '', messageBody: msg, severity: DwMessageSeverity.info });
  }
   /**
   * Determines if the user can approve/reject the request
   * @param formActionState form state
   */
  protected canPress(formActionState: DwMdFormActionState): boolean {
    const wachterUser = new WachterUserExt(this.securityService.securityContext.ApplicationUser);

    if (wachterUser.hasPermission(AppPermissions.canResendPAFChangeEmails)) {
      return true;
    }

    return false;
  }


  protected isApproved(formActionState: DwMdFormActionState): boolean {
    const payJobChange: PayJobChangeEntity = formActionState.formApi.getFormData();

    if (payJobChange && (payJobChange.StatusCv === 159 || payJobChange.StatusCv === 158)) {
        return true;
    }

    return false;
  }

}
